import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../../components/organisms/BlockInteractions';
import { BlockType } from '../../../types/api/ElementType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { RssFeedEditView } from '../views/RssFeedEditView';
import { RssFeedDefaultView } from '../views/RssFeedDefaultView';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { RssFeedViewProps } from '../RssFeed.types';

export function RssFeedInteractions({ views, activeView }: RssFeedViewProps) {
  const { uuid } = useBlockContext();
  const { t } = useSonTranslation('RssFeed');
  const { refreshCount } = useRefreshBlock();
  const buttons = views.edit
    ? createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'RssFeed:blockinteractions',
        DISPLAY_TYPE.COLLAPSIBLE,
        <RssFeedEditView {...views.edit} />
      )
    : {};

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={BlockType.rssfeed}
      headline={{
        text: t('blockinteractions.titleText'),
        hierarchy: 3,
        visible: true,
      }}
      refreshCount={refreshCount}
      activeView={activeView}
      views={views}
      buttons={buttons}
    >
      <RssFeedDefaultView {...views.default} />
    </BlockInteractions>
  );
}
